<script setup lang="ts">

import Wrapper                 from "../../Layouts/Wrapper.vue";
import Section                 from "../../CommonComponents/Section.vue";
import Container               from "../../CommonComponents/Container.vue";
import { useForm, usePage }    from "@inertiajs/vue3";
import { reactiveForm }        from "../../../Utils/reactiveForm";
import __                      from "../../../Utils/tranlation";
import { onMounted }           from "vue";
import { handleValidateForms } from "../../../Utils/helpers";
import FormErrorText           from "../../CommonComponents/FormErrorText.vue";
import ValidateFormErrorText   from "../../CommonComponents/ValidateFormErrorText.vue";
import AlertDanger             from "../../CommonComponents/AlertDanger.vue";

type TypeProps = {
    title : string,
};

defineProps<TypeProps>();

const form = useForm({
    _token: usePage().props.csrf_token,
    email: null,
    password: null,
    credentials: null,
    remember: null,
});

onMounted(() => {
    handleValidateForms();
});
</script>

<template>
    <Wrapper :title>
        <template #main>
            <Section>
                <Container>
                    <form @submit.prevent="reactiveForm($event, form, $event.target as HTMLElement, 'login.login')"
                          class="max-w-sm mx-auto needs-validation" novalidate>

                        <AlertDanger :error="form.errors.credentials"></AlertDanger>

                        <div class="mb-5">
                            <label for="email"
                                   class="block mb-2 text-sm font-medium text-gray-900
                                   dark:text-white">
                                {{ __('text_email') }}
                            </label>

                            <input type="email" id="email"
                                   v-model="form.email"
                                   class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                                   focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5
                                   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
                                   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                   pattern="^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$"
                                   minlength="3" maxlength="100"
                                   placeholder="name@flowbite.com"
                                   required/>

                            <FormErrorText :error="__('error_email')"></FormErrorText>
                            <ValidateFormErrorText :error="form.errors.email"></ValidateFormErrorText>
                        </div>

                        <div class="mb-5">
                            <label for="password"
                                   class="block mb-2 text-sm font-medium
                                   text-gray-900 dark:text-white">
                                {{ __('text_password') }}
                            </label>

                            <input type="password" id="password"
                                   v-model="form.password"
                                   class="bg-gray-50 border border-gray-300
                                   text-gray-900 text-sm rounded-lg focus:ring-blue-500
                                   focus:border-blue-500 block w-full p-2.5
                                   dark:bg-gray-700 dark:border-gray-600
                                   dark:placeholder-gray-400 dark:text-white
                                   dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                   required/>

                            <FormErrorText :error="__('error_password')"></FormErrorText>
                        </div>

                        <div class="flex items-start mb-5">
                            <div class="flex items-center h-5">
                                <input id="remember" type="checkbox" v-model="form.remember"
                                       class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3
                                            focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600
                                            dark:focus:ring-blue-600 dark:ring-offset-gray-800
                                            dark:focus:ring-offset-gray-800"/>
                            </div>

                            <label for="remember"
                                   class="ms-2 text-sm font-medium text-gray-900
                                        dark:text-gray-300">
                                {{ __('text_remember_me') }}
                            </label>
                        </div>

                        <button type="submit"
                                :disabled="form.processing"
                                class="text-white bg-blue-700
                                       hover:bg-blue-800 focus:ring-4 focus:outline-none
                                       focus:ring-blue-300 font-medium rounded-lg
                                       text-sm w-full sm:w-auto px-5 py-2.5 text-center
                                       dark:bg-blue-600 dark:hover:bg-blue-700
                                       dark:focus:ring-blue-800">
                            {{ __('text_submit') }}
                        </button>
                    </form>
                </Container>
            </Section>
        </template>
    </Wrapper>
</template>

<style scoped>

</style>
